import BtnProgress from './component/BtnProgress';
import BtnCheck from './component/BtnCheck';
import Animation from './component/Animation';
import { Form } from './component/Form';
import FlashMessage from './component/FlashMessage';
import ToggleShow from './component/ToggleShow';
import Navbar from './component/Navbar';
import Showcase from './component/Showcase';
import TechSlider from './component/TechSlider';
import ProductSlider from './component/ProductSlider';
import GallerySlider from './component/GallerySlider';
import GalleryModal from './component/GalleryModal';
import ReviewSlider from './component/ReviewSlider';
import LogoSlider from './component/LogoSlider';
import BodyGrid from './component/BodyGrid';
import Faq from './component/Faq';
import Inquiry from './component/Inquiry';
import FormSubmission from './component/FormSubmission';
import LoadMore from './component/LoadMore';
import NetteForms from 'nette-forms';

FormSubmission.init();
document.addEventListener('DOMContentLoaded', _naja.initialize.bind(_naja));
NetteForms.initOnLoad();
(window as unknown as { nette: typeof NetteForms }).nette = NetteForms;

window.addEventListener('DOMContentLoaded', () => {
    BtnProgress.init();
    BtnCheck.init();
    Animation.init();
    Form.init();
    FlashMessage.init();
    ToggleShow.init();
    Navbar.init();
    Showcase.init();
    TechSlider.init();
    ProductSlider.init();
    ReviewSlider.init();
    LogoSlider.init();
    BodyGrid.init();
    Faq.init();
    Inquiry.init();
    GallerySlider.init();
    GalleryModal.init();
    LoadMore.init();
});

window.addEventListener('pageshow', (event: PageTransitionEvent) => {
    if (event.persisted) {
        Animation.resetCountUpNumbers();
    }
});

window.addEventListener('scroll', () => {
    Animation.onScroll();
});
